// src/app/core/helpers/utils.ts
export const CURRENCY_SYMBOL = '$';

export function formatDate(date: Date | string): string {
  const d = new Date(date);
  return d.toISOString().split('T')[0];
}

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function validateEmail(email: string): boolean {

  if (email.trim().length > 0 && !isValidEmail(email)) {
    displayErrorMessage('email', 'Please enter a valid email.');
    return false;
  }
  hideErrorMessage('email');
  return true;
}

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}
export function displayErrorMessage(key: string, message: string) {
  const elements = document.querySelectorAll<HTMLElement>(`.${key}`);

  if (key === 'error') {
    elements.forEach(el => {
      el.textContent = message;
      el.classList.remove('d-none');
    });
  } else {

    elements.forEach(el => {
      el.classList.remove('d-none');
    });

    const fieldElements = document.querySelectorAll<HTMLElement>(`.${key} > span`);
    fieldElements.forEach(el => {
      el.textContent = message;
    });

  }
}
export function hideErrorMessage(key: string) {
  const elements = document.querySelectorAll<HTMLElement>(`.${key}`);

  elements.forEach(el => {
    el.classList.add('d-none');
  });

}

export function getErrorMessage(key: string, errors: any[]): string | null {
  console.log('Errors =>', errors);
  if (!Array.isArray(errors)) return null;

  const found = errors.find(err => err.hasOwnProperty(key));

  return found ? found[key] : null;
}
export function formatCurrency(amount: any) {
  const num = Number(amount) || 0;
  return CURRENCY_SYMBOL + num.toFixed(2);
}
export function getInitials(fullName: string): string {

  const words = fullName.trim().split(/\s+/).filter(word => word.trim().length > 0);

  if (words.length === 1) {
    return words[0].slice(0, 1).toUpperCase();
  }
  return words[0].slice(0, 1).toUpperCase() + words[1].slice(0, 1).toUpperCase();
}
export function buildQueryString(params?: Record<string, string | number>): string {
  if (!params) return '';
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => usp.append(key, String(value)));
  return `?${usp.toString()}`;
}